import {
  Component,
  EventEmitter,
  OnInit,
  Input,
  Output,
  OnDestroy,
} from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";
import { debounceTime, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "app-directory-list-paging",
  templateUrl: "./paging.component.html",
})
export class PagingComponent implements OnInit, OnDestroy {
  pageError: boolean;
  private destroy$ = new Subject<void>();

  @Input() currentPage: number;
  @Input() totalPages: number;

  @Output() pageClick: EventEmitter<number> = new EventEmitter();

  pagerForm: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.pagerForm = this.formBuilder.group({ page: [this.currentPage] });

    this.pagerForm
      .get("page")
      .valueChanges.pipe(debounceTime(750), takeUntil(this.destroy$))
      .subscribe((page) => {
        if (!page || +page > this.totalPages) {
          this.pageError = true;
          return;
        }
        if (+page === this.currentPage) return;

        this.pageError = false;
        this.currentPage = +page;
        this.pageClick.emit(+page);
      });
  }

  changePage(page: number) {
    this.pagerForm.controls["page"].setValue(page);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
